export default __webpack_public_path__ + "static/media/banner-4.878cd490.webp";